
import React, { useState, useEffect } from 'react';

const Navigation: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav className={`fixed top-0 left-0 w-full z-50 border-b transition-colors duration-300 ${scrolled ? 'bg-black/90 border-zinc-800 backdrop-blur-md' : 'bg-transparent border-transparent'}`}>
      <div className="max-w-[1600px] mx-auto flex items-center justify-between h-16 px-6">
        <div 
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="flex items-center gap-4 cursor-pointer group"
        >
          <div className="w-10 h-10 flex items-center justify-center text-red-600 group-hover:scale-110 transition-transform duration-300">
            <i className="fa-brands fa-hive text-3xl"></i>
          </div>
          <span className="font-mono text-sm tracking-tighter font-bold text-white uppercase flex items-center gap-2">
            Louis-88 <span className="text-zinc-600 opacity-50">/</span> Builder & White Hat Security
          </span>
        </div>

        <div className="flex items-center h-full">
          {[
            { name: 'Projects', id: 'work' },
            { name: 'Witness', id: 'witness' },
            { name: 'Contact', id: 'contact' }
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="h-16 px-6 font-mono text-[10px] uppercase tracking-widest text-zinc-500 hover:text-white hover:bg-zinc-900 border-x border-transparent hover:border-zinc-800 transition-all cursor-pointer bg-transparent"
            >
              {item.name}
            </button>
          ))}
          <button
            onClick={() => scrollTo('contact')}
            className="ml-4 px-6 py-2 bg-red-600 text-white font-mono text-[10px] uppercase tracking-widest hover:bg-red-700 transition-all border-none cursor-pointer"
          >
            Launch_Project
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
